<template>
  <div class="home">
    <CServicio/>
  </div>
</template>

<script>
// @ is an alias to /src
import CServicio from '@/components/Servicio.vue'

export default {
  name: 'Servicio',
  components: {CServicio}
}
</script>
